import videojs from 'video.js';
import { v4 as uuid } from 'uuid';
import InfoIcon from '../../../assets/images/info-white-24dp.svg';
import './notification-item.css';

const TIMEOUT = 5000;
let localize;

class NotificationItem extends videojs.getComponent('Component') {
    constructor(player, options) {
        localize = player.localize?.bind(player);
        super(player, options);
        const titleId = uuid();
        const descriptionId = uuid();

        this.el().setAttribute('role', 'listitem');
        this.el().setAttribute('aria-labelledby', titleId);
        this.addClass('mediasite-player__notification-item');

        const animationClass = 'mediasite-player__notification-item--animating-in';
        this.addClass(animationClass);
        this.one('animationend', () => {
            this.removeClass(animationClass);
        });

        const clickableEl = this.contentEl().appendChild(document.createElement('button'));
        clickableEl.className = 'mediasite-player__notification-clickable-surface';
        clickableEl.setAttribute('aria-labelledby', titleId);
        clickableEl.style.setProperty('--notification-icon', `url("${options.icon ?? InfoIcon}")`);
        clickableEl.addEventListener('click', () => this.trigger('callback'));

        const notificationTitle = clickableEl.appendChild(document.createElement('span'));
        notificationTitle.className = 'mediasite-player__notification-title';
        notificationTitle.textContent = options.title;
        notificationTitle.id = titleId;

        if (options.description) {
            const notificationDescription = clickableEl.appendChild(document.createElement('span'));
            notificationDescription.className = 'mediasite-player__notification-description';
            notificationDescription.textContent = options.description;
            notificationDescription.id = descriptionId;
            this.el().setAttribute('aria-describedby', descriptionId);
            clickableEl.setAttribute('aria-describedby', descriptionId);
        }

        const closeButton = this.contentEl().appendChild(document.createElement('button'));
        closeButton.className = 'mediasite-player__notification-close-button';
        closeButton.setAttribute('aria-label', localize('Dismiss notification'));
        closeButton.addEventListener('click', () => this.trigger('dismiss'));

        if (options.timeout === Infinity) {
            return;
        }
        this.setTimeout(() => this.trigger('timeout'), options.timeout || TIMEOUT);
    }

    animateUp() {
        return this.animate('up', true);
    }

    animateDown() {
        return this.animate('down', true);
    }

    animateOut() {
        return this.animate('out', false);
    }

    animate(direction, cleanup) {
        return new Promise(resolve => {
            const animationClass = `mediasite-player__notification-item--animating-${direction}`;
            this.addClass(animationClass);
            this.one('animationend', () => {
                if (cleanup) {
                    this.removeClass(animationClass);
                }
                resolve();
            });
        });
    }
}

export { NotificationItem };
